import { template } from "@ember/template-compiler";
import { assert } from '@ember/debug';
import { fn, hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { buildWaiter } from '@ember/test-waiters';
import { Reset, Submit } from './buttons.gts';
import { OTPInput } from './input.gts';
import type { TOC } from '@ember/component/template-only';
import type { WithBoundArgs } from '@glint/template';
let waiter = buildWaiter('ember-primitives:OTP:handleAutoSubmitAttempt');
const handleFormSubmit = (submit1: (data: {
    code: string;
}) => void, event1: SubmitEvent)=>{
    event1.preventDefault();
    assert('[BUG]: handleFormSubmit was not attached to a form. Please open an issue.', event1.currentTarget instanceof HTMLFormElement);
    let formData1 = new FormData(event1.currentTarget);
    let code1 = '';
    for (let [key1, value1] of formData1.entries()){
        if (key1.startsWith('code')) {
            code1 += value1;
        }
    }
    submit1({
        code: code1
    });
};
function handleChange(autoSubmit1: boolean | undefined, data1: {
    code: string;
    complete: boolean;
}, event1: Event) {
    if (!autoSubmit1) return;
    if (!data1.complete) return;
    assert('[BUG]: event target is not a known element type', event1.target instanceof HTMLElement || event1.target instanceof SVGElement);
    const form1 = event1.target.closest('form');
    assert('[BUG]: Cannot handle event when <OTP> Inputs are not rendered within their <form>', form1);
    const token1 = waiter.beginAsync();
    let finished1 = ()=>{
        waiter.endAsync(token1);
        form1.removeEventListener('submit', finished1);
    };
    form1.addEventListener('submit', finished1);
    // NOTE: when calling .submit() the submit event handlers are not run
    form1.requestSubmit();
}
export const OTP: TOC<{
    /**
   * The overall OTP Input is in its own form.
   * Modern UI/UX Patterns usually have this sort of field
   * as its own page, thus within its own form.
   *
   * By default, only the 'submit' event is bound, and is
   * what calls the `@onSubmit` argument.
   */ Element: HTMLFormElement;
    Args: {
        /**
     * How many characters the one-time-password field should be
     * Defaults to 6
     */ length?: number;
        /**
     * The on submit callback will give you the entered
     * one-time-password code.
     *
     * It will be called when the user manually clicks the 'submit'
     * button or when the full code is pasted and meats the validation
     * criteria.
     */ onSubmit: (data: {
            code: string;
        }) => void;
        /**
     * Whether or not to auto-submit after the code has been pasted
     * in to the collective "field".  Default is true
     */ autoSubmit?: boolean;
    };
    Blocks: {
        default: [{
                /**
         * The collective input field that the OTP code will be typed/pasted in to
         */ Input: WithBoundArgs<typeof OTPInput, 'length' | 'onChange'>;
                /**
         * Button with `type="submit"` to submit the form
         */ Submit: typeof Submit;
                /**
         * Pre-wired button to reset the form
         */ Reset: typeof Reset;
            }];
    };
}> = template(`
  <form {{on "submit" (fn handleFormSubmit @onSubmit)}} ...attributes>
    {{yield
      (hash
        Input=(component
          OTPInput length=@length onChange=(if @autoSubmit (fn handleChange @autoSubmit))
        )
        Submit=Submit
        Reset=Reset
      )
    }}
  </form>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
